import React from 'react';
import { Link } from 'react-router-dom';
import "./payment.css";

const Failure = (props) => {
    return (
      
        <div className="pricingPlan"
        style={{
          background: "url(/images/home/show-1.jpg) no-repeat scroll 0 0",
        }}>
         <div className='main-content'>
             <section className='pricing'>
             <div className="container py-5">
          {/*Title */}
          <div className="row mb-4">
            <div className="col-lg-8 mx-auto text-center">
          
            </div>
          </div>{" "}
       
          {/*Payment Form*/}
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="card ">
                <div className="card-header">
                  <div className="shadow-sm pt-4 pl-2 pr-2 pb-2">
                    {/* Credit card form tabs */}
                    <div className="row">
                        <div className="col-md-12">
                          <h6 className="card-price text-center card-plan">
                          <i className="fa fa-times-circle-o reder"></i> Payment Failure
                          </h6>
                          <hr />
                          
                           <ul className="fa-ul">
                            <li><b>{props.error!==null?props.error.resource.message:"Payment have been failed due to unknown reasons"}</b></li>
                          </ul>         
                        </div>
                       
                      </div>
                  </div>
                  {/* End */}
                  {/* Credit card form content */}
                   <div className="row">
                       <div className='col-md-12'>
                        <Link  className="subscribe btn btn-primary btn-block shadow-sm" to={"/" + props.match.params.AppId + "/premium"}>Go Back to Premium</Link>
                       </div>
                   </div>
                </div>
              </div>
            </div>
          </div>
          {/*End */}
        </div>

             </section>

         </div>
        </div>
    );
};

export default Failure;